<template>
  <footer class="footer-wrap">
    <div class="footer-top">
      <div class="container">
        

        <div class="footer-bottom">
          <div class="row align-items-center">
            <div class="col-md-6">
              <p class="copyright-text">
                <i class="ri-copyright-line"></i><span>PozitivMedical</span>.  
              </p>
            </div>
            <div class="col-md-6 text-md-end">
              <div class="social-link">
                <h6>Urmărește-ne pe:</h6>
                <ul class="social-profile list-style style1">
                  <li>
                    <a target="_blank" href="https://www.facebook.com/p/Clinica-Pozitiv-Medical-61573215824967/">
                      <i class="ri-facebook-line"></i>
                    </a>
                  </li>
                  <!-- <li>
                    <a target="_blank" href="https://twitter.com">
                      <i class="ri-twitter-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://instagram.com">
                      <i class="ri-instagram-line"></i>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://linkedin.com">
                      <i class="ri-linkedin-line"></i>
                    </a>
                  </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>